import React, { useEffect, useState, useRef, useCallback  } from 'react';
import useLoadMoreOnScroll from "react-hook-pagination";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {BASE_URL} from '../../lib/constant';
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';

const DynamicProductList = ({filter,productList,baseUrl,dispatch,searchList=false,selectedColour}) => {
  const [data, setData] = useState([]);
  const scroller = useRef();
  const {
    start,
    end,
    isFetching,
    doneFetching,
    setIsFetching,
    forceDonefetching
  } = useLoadMoreOnScroll({ fetchSize:16, scroller: scroller, limit: 1000 });
  const sortBy = useRef('matname|asc');
	var actualProducts = [];
  var lastProductNotVisited=true;
  var listHaveMoreData=true;
  var lastProductPositionLeft=0;
  const offset = useRef(0);


  useEffect(() => {
    if (start !== end) {
      setIsFetching(true);
      fetchPostsFunction(start, end);
    }
  }, [start, end]);

  const fetchPostsFunction =(start,end,force)=>{
    fetchPosts(start, end).then((post) => {
      if(post){
          if(force){
            setData([...post]);
          }
          else{
            setData([...data, ...post]);
          }
          setIsFetching(false);
      }
    });
  }

  useEffect(() => {
    if(filter){
      setData([]);
      fetchPostsFunction(0,16,true);
    }
  }, [filter])

  useEffect(() => {
    if(baseUrl){
      offset.current = end;
      setData([]);
      fetchPostsFunction(0,16,true);
    }
  }, [baseUrl])

  /* useEffect(() => {
    if(productList){
      setData(productList);
    }else{
      setData([]);
    }
  }, [productList]) */

  const fetchPosts = async (start, end) => {
    const size = end - start;
    const page = (end - offset.current) <= 0 ? 1 : ((end - offset.current) / size);
    // console.log(size,page)
    // const response = await fetch(
    //   `https://fakestoreapi.com/products?page=${page}&limit=${size}`
    // );
    // // const res = await response.json();
    // if (res?.length === 0) {
    //   forceDonefetching();
    // }
    return await loadMoreData(page,size).then(data => {
      return data;
    })
    // return res;
  };

  const loadMoreData = async (page,size) =>{
    let selectedLabels = await AuthVerify.selectedLabels();
    return await AuthVerify.selectedColours().then(async (selectedColours) =>{
        var sortByData = sortBy.current.split('|');
        const requestUrl=searchList?
        baseUrl+`&offset=${(page-1)*size}&limit=${size}&sortby=${sortByData[0]}&orderby=${sortByData[1]}${selectedColours}${selectedLabels}`:
        baseUrl+`?offset=${(page-1)*size}&limit=${size}&sortby=${sortByData[0]}&orderby=${sortByData[1]}${selectedColours}${selectedLabels}`;
        return await Axios.get(requestUrl)
        .then(function (response) {
        if (response && response.status == 200) {
            if(searchList){
                var data=response.data?.data;
                if(data.items){
                    return data.items;
                }else{
                    forceDonefetching();
                }
            }
            else{
                var data=response.data;
                if(data[0].items){
                    return data[0].items;
                }else{
                    forceDonefetching();
                }
            }
            
        }
        })
        .catch(function (error) {
          forceDonefetching();
        });
    })
  }

  const handleFilter =async (e) => {
    await AuthVerify.addSortByProducts(e.target.value).then(() => {
        setData([])
        sortBy.current=e.target.value;
        fetchPostsFunction(0,16,true);
    })
  }

  const addCompareList=async (matnum) => { 
    await AuthVerify.addToCompares(matnum).then((data) => {
        if(data){
            dispatch({type:'COMPARE'});
        }
    })
  }

  const addToWishlist = async (matnum,wishlist) => {
    if(wishlist){
      await AuthVerify.removeFromWishlist(matnum);
    }else{
      await AuthVerify.addToWishlist(matnum);
    }
    window.setProductActiveOrNot(matnum,wishlist);
    let oldProducts=data;
    oldProducts.map(item=>{
        if(item.matnum==matnum){
            item.wishlist=!wishlist;
        }
    })
    setData(oldProducts);
  }

  const RenderData =({data})=>{
    return (<Row className="products-grid" id={"products-grid"}>
    {
        data.map((product,i) => (
            <Col className={"productDetailsDiv item"} lg={3} md={4} sm={4} xs={6} key={i} id={data?.length===i+1 ? 'lastDPitem' : `notLast_${i}`}>
                <ProductCard product={product} addToWishlist={addToWishlist} addCompareList={addCompareList}/>
            </Col>
        ))}
</Row>);
}

  return (
    <Col md={12}
      id="style-14"
      ref={scroller}
      style={{ height: "2000px", overflowX: "hidden", padding:"0" }}>
      {/* <div className="toolbar">
          <Row>
            <Col sm={2} className="text-right sort-by">
              <label className="control-label" htmlfor="input-sort">Sort By:</label>
            </Col>

            <Col md={3} sm={3} className="text-right">
              <select name="product" id="products" style={{width:"70%"}} onChange={handleFilter}>
                <option value="matname|asc">Name</option>
                <option value="sellingprice|asc">Lowest Price</option>
                <option value="sellingprice|desc">Highest Price</option>
              </select>
            </Col>
          </Row>
        </div> */}
        <br></br>
        <div className="category-products">
        {data && data?.length>0 && 
            <RenderData data={data}/>
        }
      {isFetching && !doneFetching && <div className="toolbar">
                <Row>
                    <Col sm={12} className="text-center">
                    <ul className="pagination">
                        <li><span style={{fontSize:'16px'}}>Loading More .....</span></li>
                    </ul>
                    </Col>
                </Row>
            </div>}
      {doneFetching && <div className="toolbar">
                <Row>
                    <Col sm={12} className="text-center">
                    <ul className="pagination">
                        <li><span style={{fontSize:'16px'}}>That's All.</span></li>
                    </ul>
                    </Col>
                </Row>
            </div>}
        </div>
    </Col>
  );
}

export default DynamicProductList

function ProductCard(props) {
  const [qty, setQty] = useState(1);
  const { product, addToWishlist, addCompareList } = props;
  return (
    <div className="item-inner" key={product?.skukey}>
      <div className="item-img">
        <div className="item-img-info">
          <Link
            className="product-image"
            title={product?.matname}
            to={"/product-detail?matnum=" + product?.matnum}
          >
            <img
              alt={product?.matname}
              // src={img03}
              src={AuthVerify.getImageLink(product?.imageurl)}
              height="358px"
            />
          </Link>
          <div className={(product?.status === "New" && "new-label new-top-left") ||
            (product?.promotag && "hot-label hot-top-left") ||
            (product?.stock === "Sold out" && "soldout-label new-top-left") || "hidden"}>
            {(product?.status === "New" && product?.status) ||
              (product?.promotag && product?.promotag) ||
              (product?.stock === "Sold out" && product?.stock) || ""}</div>
          {/* <div className={product?.discount !== null || "hidden"}>{product?.discount}</div> */}
          <div className={product?.contract ? "contract-label" : "hidden"}>{product?.contract && "contract"}</div>
          <div className="jtv-box-hover">
            <ul className="add-to-links">
              <li>
                <Link className="link-quickview" to="/product-list" style={{ background: "none", border: "none" }}>
                  <i className="icon-magnifier-add icons"></i>
                  <span className="hidden">Quick View</span>
                </Link>
              </li>
              <li>
                <button className={`link-wishlist matnum-${product?.matnum} ${product.wishlist ? 'active' : ''}`} onClick={() => addToWishlist(product?.matnum, product.wishlist)} style={{ background: "none", border: "none" }}>
                  <i className="icon-heart icons"></i>
                  <span className="hidden">Add to Wishlist</span>
                </button>
              </li>
              {product.allowcomparison &&
                <li>
                  <button className="link-compare" onClick={() => addCompareList(product?.matnum)} style={{ background: "none", border: "none" }}>
                    <i className="icon-shuffle icons"></i>
                    <span className="hidden">Compare</span>
                  </button>
                </li>}
            </ul>
          </div>
        </div>
      </div>
      <div className="item-info">
        <div className="info-inner">
          <div className="item-title" style={{ padding: "0 7px" }}>
            <Link title={product.matname} to={"/product-detail?matnum=" + product?.matnum}>
              {product.matname}
            </Link>
          </div>
          <div className="item-content">
            <div className="rating">
              <i className={product.rating > 0 ? "fa fa-star" : "fa fa-star-o"}></i>
              <i className={product.rating > 1 ? "fa fa-star" : "fa fa-star-o"}></i>
              <i className={product.rating > 2 ? "fa fa-star" : "fa fa-star-o"}></i>
              <i className={product.rating > 3 ? "fa fa-star" : "fa fa-star-o"}></i>
              <i className={product.rating > 4 ? "fa fa-star" : "fa fa-star-o"}></i>
            </div>
            <div className="item-price">
              <div className="price-box">
                <span className="regular-price">
                  <span className="price">{`S$${product.sellingprice?.toFixed(2)} (w/GST S$${product.gstprice?.toFixed(2)})`}</span>
                  {product.promoprice &&
                    <>
                      <br />
                      <span style={{ color: 'grey', textDecoration: 'line-through', fontlastProductPositionLeft: '14px' }} className="price">U.P. S${product.usualprice}</span>
                    </>
                  }
                  {product.sellingprice != product.usualprice && !product.promoprice && false &&
                    <>
                      <br />
                      <span style={{ color: 'grey', textDecoration: 'line-through', fontlastProductPositionLeft: '14px' }} className="price">U.P. S${product.usualprice}</span>
                    </>
                  }
                </span>
              </div>
            </div>

            <div className="add-to-cart" style={{ display: "flex", justifyContent: "center" }}>
              <div className="custom pull-left">
                <button className="reduced items-count" type="button" onClick={() => { if (qty > 1) setQty(qty - 1) }}>
                  <i className="fa fa-minus">&nbsp;</i>
                </button>
                <input type="text" className="input-text qty" title="Qty" value={qty} maxLength="12" id="qty" name="qty" onChange={(e) => setQty(e.target.value)} />
                <button className="increase items-count" type="button" onClick={() => { if (qty < 12) setQty(qty + 1) }}>
                  <i className="fa fa-plus">&nbsp;</i>
                </button>
              </div>


            </div>
            <small style={{ textTransform: "none", color: "red", marginTop: "5px !important" }}>{product.multipleqty && product.multipleqty > 1 && `*Purchase quantity must be in multiples of ${product.multipleqty}.`}</small>
            <div className="action">
              <button
                className="button btn-cart"
                type="button"
                title=""
                data-original-title="Add to Cart"
                onClick={() => AuthVerify.addTocart(product, {qty: qty})}
              >
                <span>Add to Cart</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}